import { render, staticRenderFns } from "./by-product.vue?vue&type=template&id=705499c4&"
import script from "./by-product.vue?vue&type=script&lang=js&"
export * from "./by-product.vue?vue&type=script&lang=js&"
import style0 from "./by-product.vue?vue&type=style&index=0&id=705499c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports